// Mascotte KARDIF — canard détective (PNG transparent, hébergé sur notre stockage)
export const MASCOT_URL = `${process.env.REACT_APP_BACKEND_URL}/api/files/kardif/assets/mascot-duck-v2.png`;
